// extracted by mini-css-extract-plugin
export default {"section":"Error_section__eRPNT","text_error":"Error_text_error__k9jyQ","number_glow":"Error_number_glow__azAau"};